import React, {  useState } from "react";
import { createUserWithEmailAndPassword, sendPasswordResetEmail, signInWithEmailAndPassword } from 'firebase/auth';
import { auth, db } from '../Admin/Config/Config';
import { useLoginPopup } from './LoginContext';
import { doc, setDoc } from 'firebase/firestore';
import './Login.css'
import { ReactComponent as LogoSvg } from '../Navbar/Logo-55-17.svg';
import { useToast } from "../Toast.jsx/Toast";
export default function Login() {
  const { isOpen, closePopup } = useLoginPopup();
  const [signUPFlag, setSignUPFlag] = useState(false);
  const [loading, setLoading] = useState(false);
  const {showError, showSuccess} = useToast();
const [signupData, setSignupData] = useState({
  email: "",
  password: "",
  name: "",
  mobile: "",
});


const getErrorMessage = (errorCode) => {
  const errorMessages = {
    "auth/email-already-in-use":
      "This email is already in use. Please use a different email.",
    "auth/invalid-email":
      "The email address is invalid. Please enter a valid email.",
    "auth/weak-password":
      "The password is too weak. Please use a stronger password.",
    "auth/operation-not-allowed":
      "Email/password sign-up is currently disabled. Please try again later.",
    "auth/network-request-failed":
      "Network error. Please check your internet connection and try again.",
      "auth/invalid-login-credentials":
      "Invalid login credentials. Please check your email and password and try again.",
    // Add more error codes as needed
    default: "An unexpected error occurred. Please try again.",
  };

  return errorMessages[errorCode] || errorMessages.default;
};
const handleSignUp = (e) => {
  e.preventDefault();
  setLoading(true);
  const { email, password } = signupData;
 createUserWithEmailAndPassword(auth, email, password)
   .then(async(userCredential) => {
     const user = userCredential.user;
     await setDoc(
       doc(db, "users", user.uid),
       {
         uid: user.uid,
         name: signupData.name,
         email: signupData.email,
         mobile: signupData.mobile,
         createdAt: new Date(),
         photoURL:
           "https://uxwing.com/wp-content/themes/uxwing/download/peoples-avatars/default-avatar-profile-picture-male-icon.png",
       },
       { merge: true }
     );
   window.location.reload();
   })
   .catch((error) => {
    const errorCode = error.code;
     showError(getErrorMessage(errorCode));
     setLoading(false);
   });
};

 const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [email_s,setemail_s] = useState("");
  const [password_s,setpassword_s] = useState("");

  const handleEmailSiginIn = async (e) => {
    e.preventDefault();
    setLoading(true);
    signInWithEmailAndPassword(auth, email_s, password_s)
    .then(async(userCredential) => {
      window.location.reload();
    })
    .catch((error) => {
      const errorCode = error.code;
      showError(getErrorMessage(errorCode));
      setLoading(false);
    });
  };
function isValidEmail(email) {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
}
  const handleForgotPassword = () => {
  if (isValidEmail(email_s)) {
    sendPasswordResetEmail(auth, email_s)
      .then(() => {
       showSuccess("Password reset email sent successfully. Please check your inbox.");
      })
      .catch((error) => {
        showError("Failed to send password reset email. Please try again.");
      });
  } else {
    alert("Please enter a valid email address.");
  }
  }
// ================ Close popup ================ //
const cloaseDialog = () => {
  setemail_s("");
  setpassword_s("");
  setSignupData({
    email: "",
    password: "",
    name: "",
    mobile: "",
  })
  closePopup();
}
  return (
    <>
      {isOpen && !signUPFlag ? (
        <div className="h-screen w-screen bg-gray-50">
          <div className="fixed inset-0 z-50 bg-black/60 backdrop-blur-sm overflow-y-auto p-4 sm:p-6 flex items-start justify-center">
            <div className="relative container m-auto px-6">
             <div className="m-auto w-full sm:w-10/12 md:w-6/12 lg:w-4/12">
                <div className="rounded-2xl bg-white shadow-2xl relative overflow-hidden flex flex-col max-h-[90dvh]">
                  {/* Red accent bar */}
                  <div className="h-2 bg-red-600"></div>
                  
                  <button
                    onClick={() => {
                      cloaseDialog();
                    }}
                    className="absolute top-4 right-4 text-gray-400 hover:text-red-600 transition duration-300 text-2xl font-bold z-10"
                    aria-label="Close"
                  >
                    ×
                  </button>
                  
                  <div className="p-6 sm:p-8 flex-1 overflow-y-auto">
                    <div className="space-y-6 text-center">
                      <div className="flex justify-center">
                        <div className="w-20 h-20 bg-gray-100 rounded-full flex items-center justify-center">
                          <LogoSvg className="w-12 h-12 object-contain" />
                        </div>
                      </div>
                      
                      <div>
                        <h2 className="text-2xl font-bold text-gray-800 mb-2">Welcome Back</h2>
                        <p className="text-gray-500 text-sm">Sign in to your account</p>
                      </div>
                      
                      <form onSubmit={handleEmailSiginIn}>
                        <div className="space-y-4">
                          <div>
                            <label className="text-sm font-medium text-gray-700 flex items-center mb-2">
                              Email Address
                            </label>
                            <input
                              type="email"
                              onChange={(e) => setemail_s(e.target.value)}
                              required
                              placeholder="Enter your email"
                              className="px-4 py-3 bg-gray-50 text-gray-800 w-full text-sm border border-gray-200 rounded-lg focus:border-red-500 focus:ring-2 focus:ring-red-200 outline-none transition duration-200"
                            />
                          </div>
                          
                          <div>
                            <label className="text-sm font-medium text-gray-700 flex items-center mb-2">
                              Password
                            </label>
                            <div className="relative">
                              <input
                                onChange={(e) => setpassword_s(e.target.value)}
                                type={showPassword ? "text" : "password"}
                                id="password"
                                placeholder="Enter your password"
                                className="px-4 py-3 bg-gray-50 text-gray-800 w-full text-sm border border-gray-200 rounded-lg focus:border-red-500 focus:ring-2 focus:ring-red-200 outline-none transition duration-200 pr-12"
                                required
                              />
                              <button
                                type="button"
                                className="absolute inset-y-0 right-3 flex items-center text-gray-400 hover:text-red-600 transition duration-200"
                                onClick={() => setShowPassword(!showPassword)}
                              >
                                {showPassword ? (
                                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.878 9.878L3 3m6.878 6.878L21 21" />
                                  </svg>
                                ) : (
                                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                                  </svg>
                                )}
                              </button>
                            </div>
                          </div>
                          
                          <div className="flex justify-end">
                            <button
                              type="button"
                              onClick={handleForgotPassword}
                              className="text-xs font-medium text-red-600 hover:text-red-700 transition duration-200 underline"
                            >
                              Forgot password?
                            </button>
                          </div>
                        </div>
                        
                        <div className="mt-6">
                          <button
                            type="submit"
                            className="bg-red-600 hover:bg-red-700 text-white py-3 w-full rounded-lg font-medium transition duration-200 transform hover:scale-105 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2"
                          >
                            {loading ? (
                              <div className="flex items-center justify-center">
                                <svg
                                  className="animate-spin h-5 w-5 text-white mr-2"
                                  xmlns="http://www.w3.org/2000/svg"
                                  fill="none"
                                  viewBox="0 0 24 24"
                                >
                                  <circle
                                    className="opacity-25"
                                    cx="12"
                                    cy="12"
                                    r="10"
                                    stroke="currentColor"
                                    strokeWidth="4"
                                  ></circle>
                                  <path
                                    className="opacity-75"
                                    fill="currentColor"
                                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
                                  ></path>
                                </svg>
                                <span>Signing in...</span>
                              </div>
                            ) : (
                              "Sign In"
                            )}
                          </button>
                        </div>
                      </form>

                      <div className="text-center">
                        <p className="text-sm text-gray-600">
                          Don't have an account?{" "}
                          <button
                            onClick={() => setSignUPFlag(true)}
                            className="font-medium text-red-600 hover:text-red-700 transition duration-200"
                          >
                            Sign up
                          </button>
                        </p>
                      </div>
                      
                      {/* <div className="flex items-center py-4">
                        <hr className="flex-grow border-gray-200" />
                        <span className="px-4 text-xs font-medium text-gray-500 bg-white">
                          OR
                        </span>
                        <hr className="flex-grow border-gray-200" />
                      </div> */}
                    </div>
                    
                    {/* <div>
                      <button
                        onClick={handleGoogleLogin}
                        className="w-full flex items-center justify-center px-4 py-3 border border-gray-300 rounded-lg text-gray-700 bg-white hover:bg-gray-50 transition duration-200 font-medium"
                      >
                        <img
                          src="https://img.icons8.com/color/48/google-logo.png"
                          className="w-5 h-5 mr-3"
                          alt="Google logo"
                        />
                        Continue with Google
                      </button>
                      
                      <div className="mt-6 text-center">
                        <p className="text-xs text-gray-500">
                          By signing in, you agree to our{" "}
                          <a
                            href="/Terms"
                            className="text-red-600 hover:text-red-700 underline"
                          >
                            Terms and Conditions
                          </a>
                        </p>
                      </div>
                    </div> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <>
          {isOpen && signUPFlag ? (
            <div className="h-screen w-screen bg-gray-50">
              <div className="fixed inset-0 z-50 bg-black/60 backdrop-blur-sm overflow-y-auto p-4 sm:p-6 flex items-start justify-center">
                <div className="relative container m-auto px-6">
                 <div className="m-auto w-full sm:w-10/12 md:w-6/12 lg:w-4/12">
                    <div className="rounded-2xl bg-white shadow-2xl relative overflow-hidden flex flex-col max-h-[90dvh]">
                      {/* Red accent bar */}
                      <div className="h-2 bg-red-600"></div>
                      
                      <button
                        onClick={() => {
                          setSignUPFlag(false);
                          closePopup();
                        }}
                        className="absolute top-4 right-4 text-gray-400 hover:text-red-600 transition duration-300 text-2xl font-bold z-10"
                        aria-label="Close"
                      >
                        ×
                      </button>
                      
                      <div className="p-6 sm:p-8 flex-1 overflow-y-auto">
                        <div className="space-y-6 text-center">
                          {/* <div className="flex justify-center">
                            <div className="w-8 h-8 bg-gray-100 rounded-full flex items-center justify-center">
                              <LogoSvg className="w-8 h-8 object-contain" />
                            </div>
                          </div> */}
                          
                          
                          <form onSubmit={handleSignUp}>
                            <div className="space-y-4">
                              <div>
                                <label className="text-sm font-medium text-gray-700 flex items-center mb-2">
                                  Full Name <span className="text-red-500">*</span>
                                </label>
                                <input
                                  onChange={(e) =>
                                    setSignupData({
                                      ...signupData,
                                      name: e.target.value,
                                    })
                                  }
                                  type="text"
                                  placeholder="Enter your full name"
                                  className="px-4 py-3 bg-gray-50 text-gray-800 w-full text-sm border border-gray-200 rounded-lg focus:border-red-500 focus:ring-2 focus:ring-red-200 outline-none transition duration-200"
                                  required
                                />
                              </div>
                              
                              <div>
                                <label className="text-sm font-medium text-gray-700 flex items-center mb-2">
                                  Email Address <span className="text-red-500">*</span>
                                </label>
                                <input
                                  onChange={(e) =>
                                    setSignupData({
                                      ...signupData,
                                      email: e.target.value,
                                    })
                                  }
                                  type="email"
                                  placeholder="Enter your email"
                                  className="px-4 py-3 bg-gray-50 text-gray-800 w-full text-sm border border-gray-200 rounded-lg focus:border-red-500 focus:ring-2 focus:ring-red-200 outline-none transition duration-200"
                                  required
                                />
                              </div>
                              
                              <div>
                                <label className="text-sm font-medium text-gray-700 flex items-center mb-2">
                                  Phone Number <span className="text-red-500">*</span>
                                </label>
                                <input
                                  onChange={(e) =>
                                    setSignupData({
                                      ...signupData,
                                      mobile: e.target.value,
                                    })
                                  }
                                  type="tel"
                                  placeholder="Enter your phone number"
                                  className="px-4 py-3 bg-gray-50 text-gray-800 w-full text-sm border border-gray-200 rounded-lg focus:border-red-500 focus:ring-2 focus:ring-red-200 outline-none transition duration-200"
                                  required
                                />
                              </div>
                              
                              <div>
                                <label className="text-sm font-medium text-gray-700 flex items-center mb-2">
                                  Password <span className="text-red-500">*</span>
                                </label>
                                <div className="relative">
                                  <input
                                    onChange={(e) =>
                                      setSignupData({
                                        ...signupData,
                                        password: e.target.value,
                                      })
                                    }
                                    type={showPassword ? "text" : "password"}
                                    placeholder="Create a password"
                                    className="px-4 py-3 bg-gray-50 text-gray-800 w-full text-sm border border-gray-200 rounded-lg focus:border-red-500 focus:ring-2 focus:ring-red-200 outline-none transition duration-200 pr-12"
                                    required
                                  />
                                  <button
                                    type="button"
                                    className="absolute inset-y-0 right-3 flex items-center text-gray-400 hover:text-red-600 transition duration-200"
                                    onClick={() => setShowPassword(!showPassword)}
                                  >
                                    {showPassword ? (
                                      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.878 9.878L3 3m6.878 6.878L21 21" />
                                      </svg>
                                    ) : (
                                      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                                      </svg>
                                    )}
                                  </button>
                                </div>
                              </div>
                              
                              <div>
                                <label className="text-sm font-medium text-gray-700 flex items-center mb-2">
                                  Confirm Password <span className="text-red-500">*</span>
                                </label>
                                <div className="relative">
                                  <input
                                    type={showConfirmPassword ? "text" : "password"}
                                    onChange={(e) =>
                                      setSignupData({
                                        ...signupData,
                                        confirmPassword: e.target.value,
                                      })
                                    }
                                    placeholder="Confirm your password"
                                    className={`px-4 py-3 bg-gray-50 text-gray-800 w-full text-sm border rounded-lg focus:ring-2 outline-none transition duration-200 pr-12 ${
                                      signupData.confirmPassword &&
                                      signupData.password !== signupData.confirmPassword
                                        ? "border-red-500 focus:border-red-500 focus:ring-red-200"
                                        : signupData.confirmPassword &&
                                          signupData.password === signupData.confirmPassword
                                        ? "border-green-500 focus:border-green-500 focus:ring-green-200"
                                        : "border-gray-200 focus:border-red-500 focus:ring-red-200"
                                    }`}
                                    required
                                  />
                                  <button
                                    type="button"
                                    className="absolute inset-y-0 right-3 flex items-center text-gray-400 hover:text-red-600 transition duration-200"
                                    onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                                  >
                                    {showConfirmPassword ? (
                                      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.878 9.878L3 3m6.878 6.878L21 21" />
                                      </svg>
                                    ) : (
                                      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                                      </svg>
                                    )}
                                  </button>
                                </div>
                              </div>
                            </div>
                            
                            <div className="mt-6">
                              <button className="bg-red-600 hover:bg-red-700 text-white py-3 w-full rounded-lg font-medium transition duration-200 transform hover:scale-105 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2">
                                {loading ? (
                                  <div className="flex items-center justify-center">
                                    <svg
                                      className="animate-spin h-5 w-5 text-white mr-2"
                                      xmlns="http://www.w3.org/2000/svg"
                                      fill="none"
                                      viewBox="0 0 24 24"
                                    >
                                      <circle
                                        className="opacity-25"
                                        cx="12"
                                        cy="12"
                                        r="10"
                                        stroke="currentColor"
                                        strokeWidth="4"
                                      ></circle>
                                      <path
                                        className="opacity-75"
                                        fill="currentColor"
                                        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
                                      ></path>
                                    </svg>
                                    <span>Creating account...</span>
                                  </div>
                                ) : (
                                  "Create Account"
                                )}
                              </button>
                            </div>
                          </form>

                          <div className="text-center">
                            <p className="text-sm text-gray-600">
                              Already have an account?{" "}
                              <button
                                onClick={() => setSignUPFlag(false)}
                                className="font-medium text-red-600 hover:text-red-700 transition duration-200"
                              >
                                Sign in
                              </button>
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ) : null}
        </>
      )}
    </>
  );
}
